module.exports = __webpack_public_path__ + "fonts/overpass-extrabold.76ece5bd.otf";